import { useEffect, useState } from "react"
import { Col, Form, FormFeedback, Input } from "reactstrap"
import Switch from "react-switch";

import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { useOwnerUpdateMutation } from "store";


const Detail = (props: any) => {
  const [ownerOne, setOwnerOne] = useState<any>(null);
  const [isLoading, setLoading] = useState(true)
  const [is_active, setIs_active] = useState<boolean>(false);

  const [ownerUpdate, ownerUpdateResult] = useOwnerUpdateMutation();

  useEffect(() => {
    const tempIs_active = ownerOne !== null ? ownerOne?.is_active : false;
    setIs_active(tempIs_active);

    if (props?.data === null) {
      setOwnerOne(null)
      setLoading(true)
    } else {
      setLoading(false)
      setOwnerOne(props?.data)
    }
  }, [props?.data, props?.table_name, props?.id, ownerOne])

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      address: ownerOne?.address,
      owner_description: ownerOne?.owner_description,
      phone: ownerOne?.phone,
      is_active: ownerOne === undefined ? false : is_active,
    },
    validationSchema: Yup.object({
      address: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      owner_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      phone: Yup.string().typeError("Утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const updateOwnerList = {
        id: ownerOne ? ownerOne.id : 0,
        table_name: props?.table_name,
        connection_id: props?.id,
        address: values.address,
        owner_description: values.owner_description,
        phone: values.phone,
        is_active: ownerOne === undefined ? false : is_active,
      };
      ownerUpdate(updateOwnerList)
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (
    <>
      {isLoading ? (
        <Spinners setLoading={setLoading} />
      ) : (
        <>
          <Col xl={4}>
            <h5 className="fw-semibold text-center">Эзэмшигч</h5>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className="table-responsive">
                <table className="table">
                  <tbody>
                    <tr>
                      <th scope="col">Хаяг:</th>
                      <td className="fs-6">
                        <Input
                          name="address"
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address || ""}
                          invalid={
                            validation.touched.lname && validation.errors.address ? true : false
                          }
                        />
                        {validation.touched.address &&
                          validation.errors.address ? (
                          <FormFeedback type="invalid">
                            {validation.errors.address}
                          </FormFeedback>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Эзэмшигч тайлбар</th>
                      <td className="fs-6">
                        <Input
                          name="owner_description"
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.owner_description || ""}
                          invalid={
                            validation.touched.owner_description && validation.errors.owner_description ? true : false
                          }
                        />
                        {validation.touched.owner_description &&
                          validation.errors.owner_description ? (
                          <FormFeedback type="invalid">
                            {validation.errors.owner_description}
                          </FormFeedback>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Утас</th>
                      <td className="fs-6">
                        <Input
                          name="phone"
                          type="text"
                          validate={{
                            required: { value: true },
                          }}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone || ""}
                          invalid={
                            validation.touched.phone && validation.errors.phone ? true : false
                          }
                        />
                        {validation.touched.phone &&
                          validation.errors.phone ? (
                          <FormFeedback type="invalid">
                            {validation.errors.phone}
                          </FormFeedback>
                        ) : null}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Төлөв</th>
                      <td>

                        <Switch
                          uncheckedIcon={<Offsymbol />}
                          checkedIcon={<OnSymbol />}
                          className="me-1 mb-sm-8 mb-2 ms-3"
                          onColor="#626ed4"
                          onChange={() => {
                            setIs_active(!is_active);
                          }}
                          checked={is_active}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="hstack gap-2">
                <button type="submit" className="btn btn-primary w-100" > Засварлах </button>
              </div>
            </Form>
          </Col>
        </>
      )}
    </>
  );


}

export default Detail;